import { initializeApp } from "firebase/app";


const firebaseConfig = {
    apiKey: "AIzaSyCrqXhGWH2KtVHmOUUN68gQWpRCdPylVIM",
    authDomain: "asu-app-c608b.firebaseapp.com",
    projectId: "asu-app-c608b",
    storageBucket: "asu-app-c608b.appspot.com",
    messagingSenderId: "225504620045",
    appId: "1:225504620045:web:feb49f8e53c501746a6f44",
    measurementId: "G-499F9E3R0E"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

export default app